import { useContext } from 'react';
import { Delete } from '@mui/icons-material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { DropsContext } from 'contexts/DropsContext';
import { AuthContext } from 'contexts/AuthContext';
import { Grid, Typography, Box, LinearProgress } from '@mui/material';
import { toastWarning } from 'utils/toast';
import { CustomPagination } from 'utils/functions';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';
import localeText from 'utils/localeText';
import styles from './styles';
import moment from 'moment';

const Gerar = () => {
  const titulo = 'Garantia';
  const navigate = useNavigate();
  const { drops } = useContext(DropsContext);
  const { user } = useContext(AuthContext);
  const { postLoading, postDocumento } = useContext(DocumentosContext);
  const defaultValues = {
    cadastro_id: null,
    observacao: '',
    // ITENS
    produto_id: null,
    descricao: '',
    referencia: '',
    infadc: '',
    quantidade: '',
    pedcomp: '',
    przent: null,
    itens: [],
  };
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues });
  const itens = watch('itens');

  const onAdd = (values) => {
    if (!Boolean(values?.descricao)) {
      return toastWarning('Descrição não informada');
    }

    if (!Boolean(values?.referencia)) {
      return toastWarning('Referência não informada');
    }

    if (Number(values?.quantidade) <= 0) {
      return toastWarning('Quantidade inválida');
    }

    const uuid = `${values?.produto_id || '_'}${values?.descricao || '_'}${values?.referencia || '_'}${values?.infadc || '_'}`;

    const produto_duplicado = values?.itens.some((s) => s?.uuid === uuid);

    if (produto_duplicado) {
      return toastWarning('Produto já inserido');
    }

    const newItem = {
      uuid,
      produto_id: values?.produto_id,
      descricao: values?.descricao,
      referencia: values?.referencia,
      infadc: values?.infadc,
      quantidade: values?.quantidade,
      pedcomp: values?.pedcomp,
      przent: values?.przent,
    };

    setValue('itens', [newItem, ...values?.itens]);
    setValue('produto_id', null);
    setValue('descricao', '');
    setValue('referencia', '');
    setValue('infadc', '');
    setValue('quantidade', '');
  };

  const onDelete = (row) => {
    setValue(
      'itens',
      itens?.filter((i) => i?.uuid !== row?.uuid)
    );
  };

  const onSubmit = (values) => {
    let Itens = itens?.map((i) => ({
      produto_id: i?.produto_id,
      descricao: i?.descricao,
      referencia: i?.referencia,
      quantidade: i?.quantidade,
      infadc: i?.infadc,
      pedcomp: i?.pedcomp,
      przent: i?.przent,
      Aprovacoes: [{ aprova_id: 11, motivo: 'Análise de Garantia' }],
    }));

    const data = {
      Documento: {
        especie_id: 46,
        natureza_operacao_id: 54,
        users_id: user?.id,
        filial_id: user?.filial_id,
        cadastro_id: user?.entidade_id,
        dtemissao: moment().format('YYYY-MM-DD HH:mm:ss'),
        observacao: values?.observacao,
      },
      Itens: Itens?.map((i, index) => ({ ...i, sequencia: index + 1 })),
    };

    postDocumento({ data, cb: () => navigate(-1) });
  };

  const ProdutoCell = ({ row }) => {
    const lines = [
      { label: 'Referência', value: row?.referencia },
      { label: 'Nº de Série', value: row?.infadc },
      { label: 'Nº da Compra', value: row?.pedcomp },
      {
        label: 'Data da Compra',
        value: row?.przent ? moment(row?.przent).format('DD/MM/YYYY') : null,
      },
    ];

    return (
      <Box py={1} flex={1}>
        <Typography variant="body1" fontWeight="bold" mb={1}>
          {row?.descricao}
        </Typography>
        {lines.map(({ label, value }) => (
          <Box
            gap={1}
            flex={1}
            key={value}
            display="flex"
            alignItems="center"
            color="text.secondary"
          >
            <Typography variant="caption" fontWeight="bold" flex={1}>
              {label}:
            </Typography>
            <Typography variant="caption" flex={3}>
              {value || '-'}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Container>
      <Header titulo={titulo} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card title="Informações Gerais">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input
                  name="observacao"
                  control={control}
                  label="Relato do Cliente"
                  multiline
                  rows={5}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} md={4} display="flex">
          <Card title="Produto" style={styles?.card}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <VirtualDrop
                  label="Produto"
                  name="produto_id"
                  refresh="Produto"
                  control={control}
                  options={drops?.Produto}
                  onValueChange={(v) => setValue('descricao', v?.label || '')}
                />
              </Grid>
              <Grid item xs={12}>
                <Input name="descricao" control={control} label="Descrição" />
              </Grid>
              <Grid item xs={12}>
                <Input name="referencia" control={control} label="Referência" />
              </Grid>
              <Grid item xs={12}>
                <Input name="infadc" control={control} label="Nº de Série" />
              </Grid>
              <Grid item xs={12}>
                <InputMask
                  name="quantidade"
                  control={control}
                  label="Quantidade"
                />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <Typography variant="h6">Dados da NF</Typography>
              </Grid>
              <Grid item xs={12}>
                <Input name="pedcomp" control={control} label="Nº da Compra" />
              </Grid>
              <Grid item xs={12}>
                <InputMask
                  type="date"
                  name="przent"
                  control={control}
                  label="Data da Compra"
                />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <Button
                  color="primary"
                  variant="outlined"
                  loading={postLoading}
                  onClick={handleSubmit(onAdd)}
                >
                  Adicionar
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} md={8} display="flex">
          <Card title="Itens" style={styles?.card}>
            <DataGrid
              rows={itens}
              columns={[
                {
                  field: 'produto',
                  headerName: 'Produto',
                  minWidth: 400,
                  flex: 1,
                  sortable: false,
                  renderCell: (props) => <ProdutoCell {...props} />,
                },
                {
                  field: 'quantidade',
                  headerName: 'Quantidade',
                  width: 200,
                  sortable: false,
                },
                {
                  field: 'actions',
                  type: 'actions',
                  headerName: 'Ações',
                  width: 100,
                  getActions: ({ row }) => {
                    return [
                      <GridActionsCellItem
                        icon={<Delete />}
                        label="Excluir"
                        onClick={() => onDelete(row)}
                      />,
                    ];
                  },
                },
              ]}
              pageSize={5}
              pagination
              density="compact"
              disableColumnMenu
              showCellRightBorder
              showColumnRightBorder
              disableSelectionOnClick
              getRowHeight={() => 'auto'}
              getRowId={(row) => row.uuid}
              localeText={localeText}
              loading={postLoading}
              components={{
                LoadingOverlay: LinearProgress,
                Pagination: CustomPagination,
              }}
            />
          </Card>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            variant="contained"
            loading={postLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
        <Grid item xs={12} />
      </Grid>
    </Container>
  );
};

export default Gerar;
